"use strict";
// Exported Functions
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRequiredField = exports.validateName = exports.validateLastName = exports.validateFirstName = exports.validateZipCode = exports.validatePhone = exports.validateDomain = exports.validateEmail = void 0;
var isWhitespaceOnly = function (value) {
    var matches = value.match(/[^ ]/g) || [];
    return matches.length === 0;
};
var validateEmail = function (email) {
    var regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return regex.test(email);
};
exports.validateEmail = validateEmail;
var validateDomain = function (domain) {
    var regex = /^((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return regex.test(domain);
};
exports.validateDomain = validateDomain;
var validatePhone = function (phone, digitsOnly) {
    if (digitsOnly) {
        return /^\d{10}$/.test(phone);
    }
    return /^\d{3}-\d{3}-\d{4}$/.test(phone);
};
exports.validatePhone = validatePhone;
function validateZipCode(zipcode, country) {
    var zipValidationRegExModel = {
        US: /^\d{5}$|^\d{5}-\d{4}$/,
        UK: /^(GIR|[A-Z]\d[A-Z\d]??|[A-Z]{2}\d[A-Z\d]??)[ ]??(\d[A-Z]{2})$/
    };
    var countryCode = country || 'US';
    return new RegExp(zipValidationRegExModel[countryCode]).test(zipcode);
}
exports.validateZipCode = validateZipCode;
var matches = function (value) { return (value.match(/[^a-z '-]/gi) || []).length === 0; };
var validateFirstName = function (value) {
    return !isWhitespaceOnly(value) && matches(value) && value.length > 1 && value.length < 16;
};
exports.validateFirstName = validateFirstName;
var validateLastName = function (value) {
    return !isWhitespaceOnly(value) && matches(value) && value.length > 1 && value.length < 26;
};
exports.validateLastName = validateLastName;
var validateName = function (value) { return !isWhitespaceOnly(value) && matches(value); };
exports.validateName = validateName;
var validateRequiredField = function (value) {
    return value.length > 0;
};
exports.validateRequiredField = validateRequiredField;
